import { render, staticRenderFns } from "./HistoryHubland.vue?vue&type=template&id=6cc4a58f&"
import script from "./HistoryHubland.vue?vue&type=script&lang=js&"
export * from "./HistoryHubland.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports